import { render } from "./coursedetail.vue?vue&type=template&id=03ce2814&scoped=true&ts=true"
import script from "./coursedetail.vue?vue&type=script&lang=ts"
export * from "./coursedetail.vue?vue&type=script&lang=ts"

import "./coursedetail.vue?vue&type=style&index=0&id=03ce2814&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ce2814"]])

export default __exports__